<template>
  <!-- 業務報告 親コンポーネント -->
  <div id="monthlyreport">
    <CCard>
      <CCardHeader>
        <h2>業務報告</h2>
      </CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select"
                v-model="year"
                style="width: 90px"
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select"
                v-model="month"
                style="width: 70px"
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>
              <button class="btn btn-primary" @click="callList">表示</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <CCardHeader>
          <tr><td>
            <strong
              v-if="showYearMonth"
              style="font-size: 20px; font-weight: bold"
            >
              {{ selectYear }} 年 {{ selectMonth }} 月
              <span style="margin-left: 10px"></span>
              <span :style="statusColor(status)">【{{ getStatusLabel(status) }}】</span>
            </strong>
          </td></tr>
          <tr><td v-if="errors.length">
            <div style="color: red" v-for="error in errors" :key="error">
              {{ error }}
            </div>
          </td></tr>
        </CCardHeader>
        <CCardBody>
        <!-- ▼ 所属プロジェクト（カード表示） -->
        <div v-if="myProjects.length" class="mb-3 px-3">
          <h5 class="mb-2">所属プロジェクト</h5>
          <CRow>
            <CCol v-for="p in myProjects" :key="p.id" sm="12" md="6" lg="4" xl="3">
              <CCard color="info"
                    class="text-white card-select mb-3"
                    @click="openProjectModal(p.id)">
                <CCardBody class="py-3">
                  <div class="font-weight-bold">{{ p.name }}</div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
        <!-- ▲ 所属プロジェクト（カード表示） -->
          <CCardHeader><strong>詳細入力</strong></CCardHeader>
          <CRow>
            <CCol>
              <td><span class="asterisk">*</span>が付いている項目は必須入力項目です</td>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
                <ReportError
                  ref="error"
                  :task="task"
                  :plan_day="plan_day"
                  :progress="progress"
                  :plan_start="plan_start"
                  :start_day="start_day"
                  :plan_end="plan_end"
                  :end_day="end_day"
                  :details="details"
                  :problem="problem"
                  :cause="cause"
                  :measures="measures"
                  :total_time="total_time"
                  :defined="defined"
                  :expect_over="expect_over"
                  :total_over="total_over"
                  :total_night="total_night"
                  :total_holiday="total_holiday"
                  :over_reason="over_reason"
                ></ReportError>
                <div class="table-responsive">
                  <table class="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th rowspan="2" width="80px" scope="col"></th>
                        <th rowspan="2" width="210px" class="red-asterisk" scope="col">項目</th>
                        <th width="100px" class="red-asterisk" scope="col">予定日数</th>
                        <th width="110px" class="red-asterisk" scope="col">開始予定</th>
                        <th width="110px" class="red-asterisk" scope="col">完了予定</th>
                        <th colspan="5" width="90px" scope="col">先月(予定)</th>
                        <th colspan="5" width="90px" scope="col">今月(予定)</th>
                        <th colspan="5" width="95px" scope="col">来月(予定)</th>
                      </tr>
                      <tr>
                        <th class="red-asterisk" scope="col">進捗率(%)</th>
                        <th class="red-asterisk" scope="col">開始日</th>
                        <th scope="col">完了日</th>
                        <th colspan="5" scope="col">先月(実績)</th>
                        <th colspan="5" scope="col">今月(実績)</th>
                        <th colspan="5" scope="col">来月(実績)</th>
                      </tr>
                    </thead>
                    <tbody v-for="(n, index) in lists" :key="index">
                      <tr>
                        <td rowspan="2" nowrap>
                          <button
                            :disabled="statusBtn"
                            @click="deleteCheck(index)"
                            v-bind="task_id[index]"
                            class="btn btn-danger deleteButton"
                          >
                            削除
                          </button>
                        </td>
                        <td rowspan="2">
                          <ValidationProvider name="項目" rules="required">
                            <CTextarea
                              v-model="task[index]"
                              rows="4"
                              @blur="task_check"
                              style="width:200px;"
                            ></CTextarea>
                          </ValidationProvider>
                        </td>
                        <td>
                          <ValidationProvider
                            name="予定日数"
                            rules="required|numeric"
                          >
                            <CInput
                              append="日"
                              style="width:90px;"
                              v-model="plan_day[index]"
                              @blur="plan_day_check"
                            />
                          </ValidationProvider>
                        </td>
                        <td>
                          <ValidationProvider name="開始予定" rules="required">
                            <CInput
                              v-model="plan_start[index]"
                              @blur="plan_start_check"
                              @change="paint_task(0,'blue',plan_start,plan_end,index)"
                              type="date"
                              :min="date_min()"
                              :max="date_max()"
                            />
                          </ValidationProvider>
                        </td>
                        <td>
                          <ValidationProvider name="完了予定" rules="required">
                            <CInput
                              v-model="plan_end[index]"
                              @blur="plan_end_check"
                              @change="paint_task(0,'blue',plan_start,plan_end,index)"
                              type="date"
                              :min="date_min()"
                              :max="date_max()"
                            />
                          </ValidationProvider>
                        </td>
                        <!-- 色変更コンポーネント(青)呼出 -->
                        <td
                          v-for="(color, colorIndex) in blue[index].slice(0, 15)"
                          :key="colorIndex"
                          :style="{ background: color }"
                          @click="setBlue(colorIndex, index)"
                        ></td>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider
                            name="進捗率"
                            rules="required|numeric"
                          >
                            <CInput
                              append="%"
                              style="width:90px;"
                              v-model="progress[index]"
                              @blur="progress_check"
                            />
                          </ValidationProvider>
                        </td>
                        <td>
                          <ValidationProvider name="開始日" rules="required">
                            <CInput
                              v-model="start_day[index]"
                              @blur="start_day_check"
                              @change="paint_task(progress,'yellow',start_day,end_day,index)"
                              type="date"
                              :min="date_min()"
                              :max="date_max()"
                            />
                          </ValidationProvider>
                        </td>
                        <td>
                          <ValidationProvider name="完了日">
                            <CInput
                              v-model="end_day[index]"
                              @change="paint_task(progress,'yellow',start_day,end_day,index)"
                              type="date"
                              :min="date_min()"
                              :max="date_max()"
                            />
                          </ValidationProvider>
                        </td>
                        <!-- 色変更コンポーネント(黄)呼出 -->
                        <td
                          v-for="(color, colorIndex) in yellow[index].slice(0, 15)"
                          :key="colorIndex"
                          :style="{ background: color }"
                          @click="setYellow(colorIndex, index,end_day[index])"
                        ></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <CRow>
                  <CCol sm="1">
                    <button
                      :disabled="statusBtn"
                      @click="addForm"
                      class="btn btn-primary"
                    >
                      追加
                    </button>
                  </CCol>
                </CRow>
                <br />
                <CRow>
                  <CCol>
                    <table class="table table-bordered" width="100%">
                      <tr align="left">
                        <th class="red-asterisk">作業内容</th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider name="作業内容" rules="required">
                            <CTextarea
                              rows="20"
                              v-model="details"
                              @blur="details_check"
                            ></CTextarea>
                          </ValidationProvider>
                        </td>
                      </tr>
                      <tr align="left">
                        <th class="red-asterisk">問題点</th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider name="問題点" rules="required">
                            <CTextarea
                              rows="5"
                              v-model="problem"
                              @blur="problem_check"
                            ></CTextarea>
                          </ValidationProvider>
                        </td>
                      </tr>
                      <tr align="left">
                        <th class="red-asterisk">原因</th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider name="原因" rules="required">
                            <CTextarea
                              rows="5"
                              v-model="cause"
                              @blur="cause_check"
                            ></CTextarea>
                          </ValidationProvider>
                        </td>
                      </tr>
                      <tr align="left">
                        <th class="red-asterisk">対策</th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider name="対策" rules="required">
                            <CTextarea
                              rows="5"
                              v-model="measures"
                              @blur="measure_check"
                            ></CTextarea>
                          </ValidationProvider>
                        </td>
                      </tr>
                    </table>
                  </CCol>
                </CRow>
                <CCardHeader>
                  <strong>【当月】</strong> 
                  <p>※勤務表の入力があった場合、反映されます。</p>
                  <p>※基準時間に対する超過控除の表示は自社勤務時間からの計算となり参考値です。現場等での実際の超過控除時間は別途ご確認下さい。</p>
                </CCardHeader>
                <CRow>
                  <CCol>
                    <table class="table table-bordered">
                      <tr>
                        <th class="red-asterisk">勤務時間
                          <span :style="{ color: workTimeStatus.color, 'font-weight': 'bold', 'margin-left': '10px' }">
                            {{ workTimeStatus.text }}
                          </span>
                        </th>
                        <th class="red-asterisk">時間外時間</th>
                      </tr>
                      <td>
                        <ValidationProvider
                          :name="勤務時間"
                          rules="required|total_time"
                        >
                          <CInput
                            append="h:m"
                            style="margin-bottom: 3px; width: 120px"
                            type="text"
                            maxlength="10"
                            v-model="total_time"
                            @blur="total_time_check"
                          />
                        </ValidationProvider>
                      </td>
                      <td>
                        <ValidationProvider
                          :name="時間外時間"
                          rules="required|total_time"
                        >
                          <CInput
                            append="h:m"
                            style="margin-bottom: 3px; width: 120px"
                            type="text"
                            maxlength="10"
                            v-model="total_over"
                            @blur="total_over_check"
                          />
                        </ValidationProvider>
                      </td>
                      <tr>
                        <th class="red-asterisk">夜勤時間</th>
                        <th class="red-asterisk">法定休日時間</th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider
                            :name="夜勤時間"
                            rules="required|total_time"
                          >
                            <CInput
                              append="h:m"
                              style="margin-bottom: 3px; width: 120px"
                              type="text"
                              maxlength="10"
                              v-model="total_night"
                              @blur="total_night_check"
                            />
                          </ValidationProvider>
                        </td>
                        <td>
                          <ValidationProvider
                            :name="法定休日時間"
                            rules="required|total_time"
                          >
                            <CInput
                              append="h:m"
                              style="margin-bottom: 3px; width: 120px"
                              type="text"
                              maxlength="10"
                              v-model="total_holiday"
                              @blur="total_holiday_check"
                            />
                          </ValidationProvider>
                        </td>
                      </tr>
                    </table>
                  </CCol>
                </CRow>
                <CCardHeader>
                  <strong>【翌月】</strong> 
                  <p>※規定勤務時間は自動計算にて初回設定されています。</p>
                </CCardHeader>
                <CRow>
                  <CCol>
                    <table class="table table-bordered">
                      <tr>
                        <th class="red-asterisk">規定勤務時間</th>
                        <th
                          :class="{
                            'red-asterisk':
                              total_over !== '0:00' || total_over !== '00:00'
                          }"
                        >
                          時間外事由(発生時必須)
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider
                            :name="規定勤務時間"
                            rules="required|total_time"
                          >
                            <CInput
                              append="h:m"
                              style="margin-bottom: 3px; width: 120px"
                              type="text"
                              maxlength="10"
                              v-model="defined"
                              @blur="defined_check"
                            />
                          </ValidationProvider>
                        </td>
                        <td rowspan="3">
                          <ValidationProvider
                            name="時間外発生理由"
                            :rules="{required:expect_over !== '00:00'}">
                            <CTextarea
                              rows="6"
                              v-model="over_reason"
                              @blur="over_reason_check"
                            ></CTextarea>
                          </ValidationProvider>
                        </td>
                      </tr>
                      <tr>
                        <th class="red-asterisk">予定時間外時間</th>
                      </tr>
                      <tr>
                        <td>
                          <ValidationProvider
                            :name="予定時間外時間"
                            rules="required|total_time"
                          >
                            <CInput
                              append="h:m"
                              style="margin-bottom: 3px; width: 120px"
                              type="text"
                              maxlength="10"
                              v-model="expect_over"
                              @blur="expect_over_check"
                            />
                          </ValidationProvider>
                        </td>
                      </tr>
                    </table>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <table class="table table-bordered">
                      <tr>
                        <th>連絡事項・要確認事項・レビュー依頼</th>
                      </tr>
                      <tr>
                        <td>
                          <CTextarea rows="5" v-model="remarks"></CTextarea>
                        </td>
                      </tr>
                    </table>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol class="text-center">
                    <save-button
                      :label="'保存'"
                      :disabled="ObserverProps.invalid || statusBtn || activeButton"
                      @click="edit"
                      class="btn btn-primary"
                    ></save-button>
                    <br />
                    ※
                    保存後、他月次申請とまとめて「承認申請一覧」にて承認申請を行ってください。
                  </CCol>
                </CRow>
            </ValidationObserver>
          </CCol>
        </CRow>
      </CCardBody>
    </template>
    </CCard>
    <!-- モーダル：現在表示中のプロジェクト情報 -->
    <CModal
      :show.sync="showProjectModal"
      @close="showProjectModal=false"
      centered
      size="xl"
    >
      <!-- v2 は kebab-case です -->
      <CModalHeader :close-button="true">プロジェクト情報</CModalHeader>

      <!-- ローディング切替はお好みで -->
      <CModalBody v-if="!modalLoading">
        <CRow class="mb-2">
          <CCol><label class="common-label">クライアント名</label><br/><label class="common-text">{{ selectedProject.client }}</label></CCol>
          <CCol><label class="common-label">関連会社</label><br/><label class="common-text">{{ selectedProject.related }}</label></CCol>
          <CCol><label class="common-label">プロジェクト名</label><br/><label class="common-text">{{ selectedProject.project }}</label></CCol>
        </CRow>
        <hr/>
        <CRow class="mb-2">
          <CCol><label class="common-label">その他関連</label><br/><label class="common-text">{{ selectedProject.otherRelated }}</label></CCol>
          <CCol><label class="common-label">契約形態</label><br/><label class="common-text">{{ selectedProject.contract }}</label></CCol>
          <CCol><label class="common-label">その他契約事項</label><br/><label class="common-text">{{ selectedProject.otherContract }}</label></CCol>
        </CRow>
        <hr/>
        <CRow class="mb-2">
          <CCol><label class="common-label">始業時刻</label><br/><label class="common-text">{{ selectedProject.startTime }}</label></CCol>
          <CCol><label class="common-label">終業時刻</label><br/><label class="common-text">{{ selectedProject.endTime }}</label></CCol>
          <CCol><label class="common-label">休憩時間</label><br/><label class="common-text">{{ selectedProject.breakTime }}</label></CCol>
        </CRow>
        <hr/>
        <CRow>
          <CCol><label class="common-label">基準時間</label><br/><label class="common-text">{{ selectedProject.baseTime }}</label></CCol>
          <CCol><label class="common-label">開発言語</label><br/><label class="common-text">{{ selectedProject.language }}</label></CCol>
          <CCol><label class="common-label">その他必要技術</label><br/><label class="common-text">{{ selectedProject.otherTech }}</label></CCol>
        </CRow>
      </CModalBody>
      <CModalBody v-else>読み込み中…</CModalBody>

      <template #footer>
        <button class="btn btn-secondary" @click="showProjectModal=false">閉じる</button>
      </template>
    </CModal>
  </div>
</template>

<script>
import ConstList from "./../ConstList";
import SubmissionConst from "./../submission_approval/ConstList";
import axios from "axios";
import moment from "moment";
import ReportError from "./ReportError";
import SaveButton from '../common/SaveButton';

export default {
  name: "MonthlyReport",
  components: {
    ReportError,
    SaveButton,
  },
  data() {
    return {
      myProjects: [],
      modalLoading: false,
      selectedProject: {
        id: null, name: '',
        client: '', related: '', project: '',
        otherRelated: '', contract: '', otherContract: '',
        startTime: '', endTime: '', breakTime: '',
        baseTime: '', baseTimeMin: '', baseTimeMax: '',
        language: '', otherTech: ''
      },
      showProjectModal: false,
      year: "",
      month: "",
      date: "",
      writer: "",
      client: "",
      startTime: "",
      endTime: "",
      breakTime: "",
      related: "",
      project: "",
      projectList: [],
      otherRelated: "",
      company: "",
      companyList: [],
      contract: "",
      baseTime: "",
      baseTimeMin: "",
      baseTimeMax: "",
      otherContract: "",
      language: "",
      otherTech: "",
      num: 0,
      task_id: [],
      task: [],
      taskBar: [],
      plan_day: [],
      plan_start: [],
      plan_end: [],
      blue: [["", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]],
      progress: [],
      start_day: [],
      end_day: [],
      yellow: [["", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]],
      details: "",
      problem: "",
      cause: "",
      measures: "",
      total_time: "",
      defined: "",
      expect_over: "",
      total_over: "",
      total_night: "",
      total_holiday: "",
      over_reason: "",
      remarks: "",
      status: "",
      errors: [],
      submit_flg: false,
      callFlg: false,
      showYearMonth: false,
      // 状態によるボタン非活性化
      statusBtn: false,
      loading: false,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
  },

  methods: {
    callList: function() {
      this.task_id = [];
      this.task = [];
      this.plan_day = [];
      this.plan_start = [];
      this.plan_end = [];
      this.blue = [];
      this.progress = [];
      this.start_day = [];
      this.end_day = [];
      this.yellow = [];
      this.num = 0;
      this.details = "";
      this.problem = "";
      this.cause = "";
      this.measures = "";
      this.total_time = "00:00";
      this.defined = "00:00";
      this.expect_over = "00:00";
      this.total_over = "00:00";
      this.total_night = "00:00";
      this.total_holiday = "00:00";
      this.over_reason = "";
      this.remarks = "";
      (this.status = ""), (this.errors = []), (this.callFlg = false);
      (this.showYearMonth = true),
        (this.statusBtn = false),
        (this.selectYear = this.year),
        (this.selectMonth = this.month);
      this.taskBar[0]  = new Date(this.year,this.month-2, 1);
      this.taskBar[1]  = new Date(this.year,this.month-2, 6);
      this.taskBar[2]  = new Date(this.year,this.month-2, 12);
      this.taskBar[3]  = new Date(this.year,this.month-2, 18);
      this.taskBar[4]  = new Date(this.year,this.month-2, 24);
      this.taskBar[5]  = new Date(this.year,this.month-1, 1);
      this.taskBar[6]  = new Date(this.year,this.month-1, 6);
      this.taskBar[7]  = new Date(this.year,this.month-1, 12);
      this.taskBar[8]  = new Date(this.year,this.month-1, 18);
      this.taskBar[9]  = new Date(this.year,this.month-1, 24);
      this.taskBar[10] = new Date(this.year,this.month, 1);
      this.taskBar[11] = new Date(this.year,this.month, 6);
      this.taskBar[12] = new Date(this.year,this.month, 12);
      this.taskBar[13] = new Date(this.year,this.month, 18);
      this.taskBar[14] = new Date(this.year,this.month, 24);

      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/monthlyReportSelect", {
          params: {
            year: this.year,
            month: this.month
          }
        })
        .then(response => {
          if (!response.data.date) {  // 保存前表示
            // 所属プロジェクトの初期表示
            this.client = response.data.client;
            this.project = response.data.project;
            this.startTime = response.data.startTime;
            this.endTime = response.data.endTime;
            this.breakTime = response.data.breakTime;
            this.related = response.data.related;
            this.otherRelated = response.data.otherRelated;
            this.contract = response.data.contract;
            this.baseTime = response.data.baseTime;
            this.baseTimeMin = response.data.baseTimeMin;
            this.baseTimeMax = response.data.baseTimeMax;
            this.otherContract = response.data.otherContract;
            this.language = response.data.language;
            this.otherTech = response.data.otherTech;

            // 勤務表の情報表示
            if (response.data.totalTime != null) {
              this.total_time = response.data.totalTime;
              this.total_over = response.data.totalOver;
              this.total_night = response.data.totalNight;
              this.total_holiday = response.data.totalHoliday;
            }
            // 翌月勤務時間
            this.defined = response.data.defined;

            this.callFlg = true;
            return;
          }
          let n = 0;
          while (n < response.data.taskList.length) {
            this.task_id.push(response.data.taskList[n].id);
            this.task.push(response.data.taskList[n].task);
            this.plan_day.push(response.data.taskList[n].plan_day);
            this.plan_start.push(response.data.taskList[n].plan_start);
            this.plan_end.push(response.data.taskList[n].plan_end);
            this.progress.push(response.data.taskList[n].progress);
            this.start_day.push(response.data.taskList[n].start_day);
            this.end_day.push(response.data.taskList[n].end_day);

            let blueBar = [];
            let yellowBar = [];
            response.data.taskList[n].blue.split("").forEach(element => {
              if (element === "0") {
                blueBar.push("");
              } else {
                blueBar.push("blue");
              }
            });
            this.blue.push(blueBar);
            response.data.taskList[n].yellow.split("").forEach(element => {
              if (element === "0") {
                yellowBar.push("");
              } else if(response.data.taskList[n].end_day=='') {
                yellowBar.push("red");
              }else {
                yellowBar.push("yellow");
              }
            });
            this.yellow.push(yellowBar);
            this.num++;
            n++;
          }  // 保存後表示
          this.date = response.data.date;
          this.client = response.data.client;
          this.startTime = response.data.startTime;
          this.endTime = response.data.endTime;
          this.breakTime = response.data.breakTime;
          this.related = response.data.related;
          this.project = response.data.project;
          this.otherRelated = response.data.otherRelated;
          this.contract = response.data.contract;
          this.baseTime = response.data.baseTime;
          this.baseTimeMin = response.data.baseTimeMin;
          this.baseTimeMax = response.data.baseTimeMax;
          this.otherContract = response.data.otherContract;
          this.language = response.data.language;
          this.otherTech = response.data.otherTech;
          this.taskList = response.data.taskList;
          this.details = response.data.details;
          this.problem = response.data.problem;
          this.cause = response.data.cause;
          this.measures = response.data.measures;
          this.total_time = response.data.totalTime;
          this.defined = response.data.defined;
          this.expect_over = response.data.expectOver;
          this.total_over = response.data.totalOver;
          this.total_night = response.data.totalNight;
          this.total_holiday = response.data.totalHoliday;
          this.over_reason = response.data.overReason;
          this.remarks = response.data.remarks;
          this.callFlg = true;
          this.showYearMonth = true;
          this.selectYear = this.year;
          this.selectMonth = this.month;
          this.status = response.data.status;
          // 承認待ち状態はメッセージ表示とボタン非活性化
          if (this.status == ConstList.APPROVAL_PENDING) {
            this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
            this.statusBtn = true;
            return;
          }
          // 承認済み状態はメッセージ表示とボタン非活性化
          if (this.status == ConstList.APPROVAL) {
            this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
            this.statusBtn = true;
            return;
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    setBlue: function(colorIndex, index) {
      if (this.blue[index][colorIndex] === "blue") {
        this.blue[index].splice(colorIndex, 1, "");
      } else {
        this.blue[index].splice(colorIndex, 1, "blue");
      }
    },
    setYellow: function(colorIndex, index,end) {
      if (this.yellow[index][colorIndex] === "yellow") {
        this.yellow[index].splice(colorIndex, 1, "");
      } else {
        if(end=='')  this.yellow[index].splice(colorIndex, 1, "red");
        else this.yellow[index].splice(colorIndex, 1, "yellow");
      }
    },

    edit: function() {
      if (this.submit_flg) return;
      this.loading = true;
      this.submit_flg = true; 
      let n = 0;
      const taskList = [];
      const formattedMonth =
        this.month.length === 1 ? "0" + this.month : this.month;

      while (n < this.num) {
        const item = {
          task: this.task[n],
          planDay: this.plan_day[n],
          planStart: this.plan_start[n],
          planEnd: this.plan_end[n],
          blue: this.blue[n],
          progress: this.progress[n],
          startDay: this.start_day[n],
          endDay: this.end_day[n],
          yellow: this.yellow[n]
        };
        taskList.push(item);
        n++;
      }
      this.items = {
        date: this.year + "-" + formattedMonth + "-01",
        related: this.related,
        otherRelated: this.otherRelated,
        contract: this.contract,
        baseTime: this.baseTime,
        otherContract: this.otherContract,
        language: this.language,
        otherTech: this.otherTech,
        taskList: taskList,
        details: this.details,
        problem: this.problem,
        cause: this.cause,
        measures: this.measures,
        totalTime: this.total_time,
        defined: this.defined,
        expectOver: this.expect_over,
        totalOver: this.total_over,
        totalNight: this.total_night,
        totalHoliday: this.total_holiday,
        overReason: this.over_reason,
        remarks: this.remarks
      };
      axios
        .post(
          process.env.VUE_APP_API_ORIGIN + "/updateMonthlyReport",
          this.items
        )
        .then(() => {
          this.submit_flg = false;
          alert(ConstList.REGISTER_MESSAGE);
          this.callList();
        })
        .catch(error => {
          this.submit_flg = false;
          this.callFlg = false;
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 入力欄の追加
    addForm: function() {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.num++;
      this.blue.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ]);
      this.yellow.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ]);
      this.task.splice(this.num - 1, 1, "");
      this.plan_day.splice(this.num - 1, 1, "");
      this.plan_start.splice(this.num - 1, 1, "");
      this.plan_end.splice(this.num - 1, 1, "");
      this.progress.splice(this.num - 1, 1, "");
      this.start_day.splice(this.num - 1, 1, "");
      this.end_day.splice(this.num - 1, 1, "");
    },
    // 値が入力されていた場合の削除確認
    deleteCheck(index) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      const setBlue = this.blue[index].some(element => element !== "");
      const setYellow = this.yellow[index].some(element => element !== "");
      // 画面上のデータを削除
      if (
        this.task[index] ||
        this.plan_day[index] ||
        this.plan_start[index] ||
        this.plan_end[index] ||
        this.progress[index] ||
        this.start_day[index] ||
        this.end_day[index] ||
        setBlue ||
        setYellow
      ) {
        if (
          confirm(
            "データが入力されていますが" +
              (index + 1) +
              "行目を削除してもよろしいですか？"
          )
        );
        else {
          // キャンセルした場合
          return;
        }
      }
      // 成功時の行の削除
      this.task_id.splice(index, 1);
      this.task.splice(index, 1);
      this.plan_day.splice(index, 1);
      this.plan_start.splice(index, 1);
      this.plan_end.splice(index, 1);
      this.progress.splice(index, 1);
      this.start_day.splice(index, 1);
      this.end_day.splice(index, 1);
      this.blue.splice(index, 1);
      this.yellow.splice(index, 1);
      this.lists.splice(index, 1);
      this.num--;
    },
    task_check: function() {
      this.$refs.error.task_empty();
    },
    plan_day_check: function() {
      this.$refs.error.plan_day_empty();
      this.$refs.error.plan_day_regex();
    },
    progress_check: function() {
      this.$refs.error.progress_empty();
      this.$refs.error.progress_regex();
    },
    plan_start_check: function() {
      this.$refs.error.plan_start_empty();
    },
    plan_end_check: function() {
      this.$refs.error.plan_end_empty();
    },
    start_day_check: function() {
      this.$refs.error.start_day_empty();
    },
    details_check: function() {
      this.$refs.error.details_empty();
    },
    problem_check: function() {
      this.$refs.error.problem_empty();
    },
    cause_check: function() {
      this.$refs.error.cause_empty();
    },
    measure_check: function() {
      this.$refs.error.measure_empty();
    },
    total_time_check: function() {
      this.$refs.error.total_time_empty();
      this.$refs.error.total_time_regex();
    },
    defined_check: function() {
      this.$refs.error.defined_empty();
      this.$refs.error.defined_regex();
    },
    expect_over_check: function() {
      this.$refs.error.expect_over_empty();
      this.$refs.error.expect_over_regex();
    },
    total_over_check: function() {
      this.$refs.error.total_over_empty();
      this.$refs.error.total_over_regex();
    },
    total_night_check: function() {
      this.$refs.error.total_night_empty();
      this.$refs.error.total_night_regex();
    },
    total_holiday_check: function() {
      this.$refs.error.total_holiday_empty();
      this.$refs.error.total_holiday_regex();
    },
    over_reason_check: function() {
      if (this.total_over !== "00:00") {
        this.$refs.error.over_reason_empty();
      }
    },
    date_min() {
      return ConstList.DATE_MIN;
    },
    date_max() {
      return ConstList.DATE_MAX;
    },
    // タスクカラー自動描画
    paint_task(progress,color,start,end,index){
      const task_start = new Date(start[index]);
      const task_end = new Date(end[index]);
      const taskBar = this.taskBar;
      let startIndex=0;
      let endIndex=0;
      // 開始時期
      for (let i=0; i<taskBar.length;i++){
        if(taskBar[i] >= task_start) {
          startIndex=i-1;
          break;
        }
      }if(start[index] == ''){
        startIndex = taskBar.length+1;
        endIndex =taskBar.length+1;
      // 終了時期
      }else{
        if(end[index] == '') {
          if (color==='yellow') {
            endIndex=9;
            color='red';
          }else{
            endIndex = startIndex;
          }
        } else {
          let i=startIndex;
          for (i; i<taskBar.length;i++){
            if(taskBar[i] > task_end) {
              endIndex=i-1;
              break;
            }
          }
          if (i == taskBar.length) {
            endIndex = taskBar.length-1;
          }
        }
      }
      for (let i=0;i<taskBar.length;i++){
        if (i<startIndex || endIndex<i) {
          if(color==='blue')  this.blue[index].splice(i, 1, "");
          else                this.yellow[index].splice(i, 1, "");
        } else {
          if(color==='blue')  this.blue[index].splice(i, 1, color);
          else                this.yellow[index].splice(i, 1, color);
        }
      }
    },
    // 表示用のラベル変換
    getStatusLabel(status) {
      if (!status) {
        return ConstList.UNSUBMITTED; // '未申請'
      }
      return status;
    },
    // 承認状態の識別
    statusColor(status) {
      const label = this.getStatusLabel(status);
      switch (label) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED:
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    hmToMinutes(v) {
      if (v === null || v === undefined) return NaN;
      const s = String(v).trim();
      if (s === '') return NaN;

      // "H:MM" 形式
      if (s.includes(':')) {
        const [h, m = '0'] = s.split(':');
        const hh = Number(h);
        const mm = Number(m);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) return NaN;
        return hh * 60 + mm;
      }

      // 数字だけの場合 → 「時間」と解釈する
      const hh = Number(s);
      if (!Number.isFinite(hh)) return NaN;
      return hh * 60;   // ★ ここを「分」ではなく「時間→分」に修正
    },

    formatDiff(mins) {
      const abs = Math.abs(mins);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      // 分は必ず2桁表示
      return `${h}:${m.toString().padStart(2, '0')}`;
    },
   fetchMyProjects() {
     axios
       .get(process.env.VUE_APP_API_ORIGIN + "/projects")
       .then(({ data }) => { this.myProjects = data || []; })
       .catch(error => {
         axios.get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`)
           .then(() => alert(ConstList.SYSTEM_ERROR))
           .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
       });
   },
  // カードから p を受け取る
  openProjectModal(projectId) {
    this.modalLoading = true;
    axios
      .get(`${process.env.VUE_APP_API_ORIGIN}/projects/${projectId}`)
      .then(({ data }) => {
        // どちらのキーでも拾うユーティリティ
        const v = (snake, camel) => (data[snake] ?? data[camel] ?? '');

        this.selectedProject = {
          id:            data.id ?? null,
          client:        v('company_name',   'companyName'),
          project:       v('name',           'name'),
          related:       v('related',        'related'),
          otherRelated:  v('other_related',  'otherRelated'),
          contract:      v('contract',       'contract'),
          otherContract: v('other_contract', 'otherContract'),
          startTime:     v('start_time',     'startTime'),
          endTime:       v('end_time',       'endTime'),
          breakTime:     v('break_time',     'breakTime'),
          baseTime:      v('base_time',      'baseTime'),
          baseTimeMin:   v('base_time_min',  'baseTimeMin'),
          baseTimeMax:   v('base_time_max',  'baseTimeMax'),
          language:      v('language',       'language'),
          otherTech:     v('other_tech',     'otherTech'),
        };
        this.showProjectModal = true;
      })
      .catch(error => {
        axios.get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`)
          .then(() => alert(ConstList.SYSTEM_ERROR))
          .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
      })
      .finally(() => {
        this.modalLoading = false;
      });
    },
  },

  computed: {
    // 入力欄を追加・削除出来るようにする
    lists: function() {
      return Array.from(Array(this.num).keys());
    },
    // 保存ボタンの活性非活性
    activeButton: function () {
      const list = this.num;
      const task = this.task;
      const plan_day = this.plan_day;
      const plan_start = this.plan_start;
      const plan_end = this.plan_end;
      // 行を全て削除した場合、非活性とする
      if (list === 0){
        return true;
      }
      for (let i = 0; i < list; i++) {
        if (!task[i] || !plan_day[i] || !plan_start[i] || !plan_end[i]) {
          // 全ての行から一つでも必須項目が入力されていない場合、非活性とする
          return true;
        }
      }
      // 全ての必須項目が入力されている場合、活性化する
      return false;
    },
    workTimeStatus() {
      const totalMin = this.hmToMinutes(this.total_time);
      const minMin   = this.hmToMinutes(this.baseTimeMin);
      const maxMin   = this.hmToMinutes(this.baseTimeMax);

      const hasTotal = Number.isFinite(totalMin);
      const hasMin   = Number.isFinite(minMin);
      const hasMax   = Number.isFinite(maxMin);
      const BAND5H   = 5 * 60;

      // total 未入力や不正な場合のみ「基準時間内」
      if (!hasTotal) return { text: '基準時間内', color: 'green' };

      if (!hasMin && !hasMax) return { text: '基準時間内', color: 'green' };

      if (hasMax && totalMin > maxMin) {
        return { text: `【超過】${this.formatDiff(totalMin - maxMin)}`, color: 'red' };
      }
      if (hasMin && totalMin < minMin) {
        return { text: `【控除】${this.formatDiff(minMin - totalMin)}`, color: 'blue' };
      }
      // 上限 - 5H 以内 → オレンジ
      if (hasMax && totalMin >= (maxMin - BAND5H) && totalMin <= maxMin) {
        return { text: '基準時間内', color: 'orange' };
      }
      // 下限 + 5H 以内 → 水色
      if (hasMin && totalMin >= minMin && totalMin <= (minMin + BAND5H)) {
        return { text: '基準時間内', color: '#00BFFF' }; // water-light（お好みで 'deepskyblue' でも可
      }
      return { text: '基準時間内', color: 'green' };
    },
  },

  mounted: function() {
    let today = moment();
    if (today.date() < 10) {
      today = today.subtract(1, 'months');
    }
    this.year = today.format("YYYY");
    this.month = today.format("M");
    this.fetchMyProjects();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
th,
button {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

.common-label {
  font-size: 10px;
}

.common-text {
  font-size: 15px;
  font-family: "Sawarabi Gothic", sans-serif;
}

.deleteButton {
  position: relative;
  bottom: 5px;
  right: 2px;
}

button:disabled {
  cursor: not-allowed;
}
.asterisk {
  color: red;
}
.red-asterisk::after {
  content: "*";
  color: red;
}
</style>
